module.exports = __webpack_public_path__ + "img/avatar-02.7dda0d35.png";